import { getBlog, updateBlog } from "./blogAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  blog: {},
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const fetchBlog = createAsyncThunk("blog/fetchBlog", async (id) => {
  const blog = await getBlog(id);
  return blog;
});
export const fetchUpdateBlog = createAsyncThunk(
  "blog/fetchUpdateBlog",
  async (id) => {
    console.log(id.updatedData.id);
    const blog = await updateBlog(id.updatedData);
    return blog;
  }
);

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    likeBlog: (state, action) => {
      state.blog.likes += 1;
      // state.blogs.blogs.map((blog) => {
      //   if (blog.id === state.blog.id) blog.likes += 1;
      //   return blog;
      // });
    },
    saveUnsaveBlog: (state, action) => {
      state.blog.isSaved = !state.blog.isSaved;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlog.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchBlog.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blog = action.payload;
      })
      .addCase(fetchBlog.rejected, (state, action) => {
        state.isLoading = false;
        state.blog = {};
        state.isError = true;
        state.error = action.error?.message;
      });

  },
});

export default blogSlice.reducer;

export const { likeBlog, saveUnsaveBlog } = blogSlice.actions;
